/**
 * Watch History plugin — consumes Playback Session + Event Bus (Sprint 6C).
 */
import { createPlugin } from "../createPlugin";
import { PlayerEvent } from "../../Core/PlayerEvents";
import { PlaybackPlatformEvent } from "../../Core/PlaybackPlatformEvents";

/**
 * @param {object} options
 * @param {function} options.recordHistory (contentId) => void|Promise
 * @param {function} [options.getStateService]
 */
export function createWatchHistoryPlugin(options) {
  options = options || {};
  var recordHistory = options.recordHistory || function () {};

  return createPlugin({
    name: "watch-history",
    version: "1.0.0",
    onRegister: function (ctx) {
      ctx._history = { recordedPlay: false, recordedEnd: false };
    },
    onReady: function (ctx) {
      var svc =
        typeof options.getStateService === "function"
          ? options.getStateService()
          : null;
      if (svc && svc.registerPluginName) {
        svc.registerPluginName("watch-history");
      }
    },
    onEvent: function (eventName, payload, ctx) {
      var svc =
        typeof options.getStateService === "function"
          ? options.getStateService()
          : null;
      if (!svc) return;

      var intro = svc.getIntro && svc.getIntro();
      if (intro && intro.active) return;

      var content = svc.getContent && svc.getContent();
      if (!content || !content.contentId) return;
      if (content.mediaKind === "trailer") return;

      var isPlay =
        eventName === PlayerEvent.PLAYBACK_STARTED ||
        eventName === PlayerEvent.PLAY ||
        eventName === PlaybackPlatformEvent.PLAY;
      var isEnded =
        eventName === PlayerEvent.PLAYBACK_ENDED ||
        eventName === PlaybackPlatformEvent.ENDED ||
        eventName === "ended";

      if (isPlay && !ctx._history.recordedPlay) {
        ctx._history.recordedPlay = true;
        try {
          recordHistory(content.contentId);
        } catch (e) {
          /* isolate */
        }
        if (svc.getSession) {
          svc.getSession().update("watchHistory", { recorded: true });
        }
      }

      if (isEnded && !ctx._history.recordedEnd) {
        ctx._history.recordedEnd = true;
        try {
          recordHistory(content.contentId);
        } catch (e) {
          /* isolate */
        }
      }
    },
  });
}

export default createWatchHistoryPlugin;
